"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _2 = require("..");

var _useStaticInfo = require("../hooks/useStaticInfo");

var _useRoutePath = require("../hooks/useRoutePath"); //

/**
 *
 * @param {string} path
 * @returns {React.ComponentType<{}> | false}
 */


function getTemplateForPath(path) {
  var is404 = path === '404';
  var Comp = _2.templatesByPath[path] || false;

  if (!Comp && _2.templateErrorByPath[path]) {
    is404 = true;
    Comp = _2.templatesByPath['404'] || false;
  }

  return {
    is404: is404,
    Comp: Comp
  };
}
/**
 *
 *
 * @param {string} path
 * @returns {React.ReactNode | false}
 */


function getComponentForPath(path) {
  var _getTemplateForPath = getTemplateForPath(path),
      Comp = _getTemplateForPath.Comp,
      is404 = _getTemplateForPath.is404;

  if (is404 || !Comp) {
    return false;
  }

  return _react["default"].createElement(Comp, {
    is404: is404
  });
}

var RoutesInner = function RoutesInner(_ref) {
  var routePath = _ref.routePath,
      renderFn = _ref.render; // Let the user specify a manual routePath.
  // This is useful for animations where multiple routes
  // might be rendered simultaneously

  var staticInfo = (0, _useStaticInfo.useStaticInfo)(); // eslint-disable-next-line

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      _ = _useState2[0],
      setCount = _useState2[1]; // If in production, make sure the staticInfo is ingested into the
  // cache


  (0, _react.useState)(function () {
    // useState's initializer will only fire once per component instance,
    // and it will fire during the first render (unlike an effect, which
    // only fires after the first render). Think of it like a constructor call.
    if (process.env.REACT_STATIC_ENV === 'production' && staticInfo) {
      var path = staticInfo.path,
          sharedData = staticInfo.sharedData,
          sharedHashesByProp = staticInfo.sharedHashesByProp,
          template = staticInfo.template; // Hydrate routeInfoByPath with the embedded routeInfo

      _2.routeInfoByPath[path] = staticInfo; // Hydrate sharedDataByHash with the embedded routeInfo

      Object.keys(sharedHashesByProp).forEach(function (propKey) {
        _2.sharedDataByHash[sharedHashesByProp[propKey]] = sharedData[propKey];
      }); // In SRR and production, synchronously register the template for the
      // initial path

      (0, _2.registerTemplateForPath)(path, template);
    }
  });
  (0, _react.useEffect)(function () {
    return (0, _2.onReloadTemplates)(function () {
      setCount(function (old) {
        return old + 1;
      });
    });
  }); // If SSR, force the routePath to be the statically exported one

  if (typeof document === 'undefined') {
    routePath = staticInfo.path;
  } else if (!routePath) {
    // If a routePath is still not defined in the browser,
    // use the window location as the defualt
    routePath = decodeURIComponent(window.location.href);
  }

  routePath = (0, _useRoutePath.useRoutePath)(routePath); // Try and get the template

  var _getTemplateForPath2 = getTemplateForPath(routePath),
      Comp = _getTemplateForPath2.Comp,
      is404 = _getTemplateForPath2.is404;

  if (!Comp) {
    if (is404) {
      throw new Error('Neither the page template or 404 template could be found. This means something is terribly wrong. Please, file an issue!');
    } // Suspend while we fetch the resource


    throw Promise.all([new Promise(function (resolve) {
      return setTimeout(resolve, 500);
    }), (0, _2.prefetch)(routePath, {
      priority: true
    })]);
  }

  return _react["default"].createElement(_useRoutePath.routePathContext.Provider, {
    value: routePath
  }, renderFn ? renderFn({
    routePath: routePath,
    getComponentForPath: getComponentForPath
  }) : _react["default"].createElement(Comp, {
    is404: is404
  }));
};

var Routes = function Routes(_ref2) {
  var originalProps = (0, _extends2["default"])({}, _ref2); // Once a routePath goes into the Routes component,
  // useRoutePath must ALWAYS return the routePath used
  // in its parent, so we pass it down as context
  // Get the Routes hook

  var CompWrapper = (0, _react.useMemo)(function () {
    return _2.plugins.Routes(function (props) {
      return _react["default"].createElement(RoutesInner, props);
    });
  }, [_2.plugins]); // Pass all props so that plugins can use it

  return _react["default"].createElement(CompWrapper, originalProps);
};

var _default = Routes;
exports["default"] = _default; //# sourceMappingURL=data:application/json;charset=utf-8;base64,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

void function register() {
  /* react-hot-loader/webpack */
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }
  /* eslint-disable camelcase, no-undef */


  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports;
  /* eslint-enable camelcase, no-undef */

  if (!webpackExports) {
    return;
  }

  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/build/repo/node_modules/react-static/lib/browser/components/Routes.js");
    return;
  }
  /* eslint-disable no-restricted-syntax */


  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */
    if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }

    var namedExport = void 0;

    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }

    reactHotLoader.register(namedExport, key, "/opt/build/repo/node_modules/react-static/lib/browser/components/Routes.js");
  }
}();